import {
  PersonalDetailsPayload,
  PersonalDetailsResponse,
} from "@/utils/types/NPS/Stepper/PersonalDetails";
import { post, put } from "@/services/axiosUitils";

const baseUrl = "/nps/registration/start/";

const personalDetailsBaseUrl = "/nps/registration";

class PersonalDetailsService {
  createPersonalDetails = async (
    payload: PersonalDetailsPayload
  ): Promise<PersonalDetailsResponse> => {
    const response = await post<PersonalDetailsResponse>(`${baseUrl}`, payload);
    return response;
  };

  updatePersonalDetailsById = async (
    id: string,
    payload: PersonalDetailsPayload
  ): Promise<PersonalDetailsResponse> => {
    const response = await put<PersonalDetailsResponse>(
      `${personalDetailsBaseUrl}/${id}/personal/`,
      payload
    );
    return response;
  };
}

const instance = new PersonalDetailsService();
export default instance;
